import { React } from "react";
import { SocialIcon } from "react-social-icons";

export default function footer() {
    return (
        <div id="footer" >
            <div className="container mx-auto flex-wrap justify-between">
                <div className="inline-flex py-3 px-3 my-6">
                    <SocialIcon
                        url="https://twitter.com/anant_says"
                        className="mr-4"
                        target="_blank"
                        fgColor="#fff"
                        style={{ height: 35, width: 35 }}
                    />
                    <SocialIcon
                        url="https://github.com/anant-mhl"
                        className="mr-4"
                        target="_blank"
                        fgColor="#fff"
                        style={{ height: 35, width: 35 }}
                    />
                    <SocialIcon
                        url="https://linkedin.com/in/anant30"
                        className="mr-4"
                        target="_blank"
                        fgColor="#fff"
                        style={{ height: 35, width: 35 }}
                    />
                </div>
            </div>
        </div>
    )
}